/* La Ferme Carbon-eau — Shorts façon stories. Rien n'est chargé avant le clic (seule la miniature) :
   YouTube : iframe youtube-nocookie créée à l'ouverture ; vidéo hébergée (data-src) : <video> créée
   à l'ouverture avec src posé à ce moment. Les deux sont détruits à la fermeture / au changement. */
(function(){
  var cur=null, lastFocus=null;
  function embed(id){
    var f=document.createElement('iframe');
    f.src='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(id)+'?autoplay=1&playsinline=1&rel=0&modestbranding=1';
    f.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';
    f.allowFullscreen=true; f.title='YouTube'; f.setAttribute('referrerpolicy','strict-origin-when-cross-origin');
    return f;
  }
  function mkVideo(src, poster){
    var v=document.createElement('video');
    v.setAttribute('playsinline',''); v.playsInline=true; v.controls=true; v.autoplay=true; v.preload='none';
    if(poster && poster.indexOf('data:')!==0) v.poster=poster;
    v.src=src; var p=v.play&&v.play(); if(p&&p.catch) p.catch(function(){});
    return v;
  }
  function clear(box){
    box.querySelectorAll('video').forEach(function(v){ try{v.pause();}catch(e){} v.removeAttribute('src'); try{v.load();}catch(e){} v.remove(); });
    box.querySelectorAll('iframe').forEach(function(i){ i.src='about:blank'; i.remove(); });
  }
  function cards(sec){return sec.querySelectorAll('.ce-st-card[data-short],.ce-st-card[data-src]');}
  function show(sec, card){
    var o=sec.querySelector('[data-ce-story]'); if(!o||!card) return;
    var list=cards(sec), n=Array.prototype.indexOf.call(list,card); if(n<0) n=+card.dataset.n||0;
    o.querySelector('.ce-story__title').textContent=card.dataset.title||'';
    var sub=o.querySelector('.ce-story__sub'); if(sub) sub.textContent=card.dataset.title||sub.dataset.default||'';
    o.querySelector('.ce-story__poster').src=card.dataset.img;
    o.querySelectorAll('.ce-story__bars i').forEach(function(b,k){b.className=k<n?'done':(k===n?'now':'');});
    var box=o.querySelector('.ce-story__player'); clear(box);
    if(!o.hasAttribute('data-mock')){
      if(card.dataset.src) box.appendChild(mkVideo(card.dataset.src, card.dataset.img));
      else if(card.dataset.short) box.appendChild(embed(card.dataset.short));
    }
    var nx=o.querySelector('[data-ce-next]'); if(nx) nx.hidden=list.length<2;
    if(o.hidden){ lastFocus=document.activeElement; o.hidden=false; document.documentElement.classList.add('ce-story-open'); }
    cur={sec:sec,n:n};
    var x=o.querySelector('[data-ce-close]'); if(x) x.focus({preventScroll:true});
  }
  function close(){
    if(!cur) return;
    var o=cur.sec.querySelector('[data-ce-story]');
    clear(o.querySelector('.ce-story__player'));
    o.hidden=true; document.documentElement.classList.remove('ce-story-open'); cur=null;
    if(lastFocus&&lastFocus.focus) lastFocus.focus({preventScroll:true});
  }
  document.addEventListener('click',function(e){
    var t=e.target;
    var card=t.closest&&t.closest('[data-ce-shorts] .ce-st-card[data-short],[data-ce-shorts] .ce-st-card[data-src]');
    if(card){ e.preventDefault(); show(card.closest('[data-ce-shorts]'), card); return; }
    if(!cur) return;
    if(t.closest('[data-ce-close]') || t.matches('[data-ce-story]')){ e.preventDefault(); close(); return; }
    if(t.closest('[data-ce-next]')){ e.preventDefault(); var l=cards(cur.sec); show(cur.sec, l[(cur.n+1)%l.length]); }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&cur) close(); });
  // points de défilement du rail
  function hint(sec){
    var r=sec.querySelector('.ce-shorts__rail'), h=sec.querySelector('.ce-shorts__hint'); if(!r||!h) return;
    var dots=h.querySelectorAll('i'), t;
    function up(){ var max=r.scrollWidth-r.clientWidth, k=max>0?Math.round(r.scrollLeft/max*(dots.length-1)):0;
      dots.forEach(function(d,j){d.classList.toggle('is-on',j===k);}); }
    function fit(){ h.hidden = r.scrollWidth <= r.clientWidth + 1; up(); }
    if(!r.dataset.ceHint){ r.dataset.ceHint='1'; r.addEventListener('scroll',up,{passive:true});
      if('ResizeObserver' in window) new ResizeObserver(fit).observe(r);
      else window.addEventListener('resize',function(){ clearTimeout(t); t=setTimeout(fit,150); }); }
    fit();
  }
  function init(){ document.querySelectorAll('[data-ce-shorts]').forEach(hint); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',function(e){ if(e.target.querySelector('[data-ce-shorts]')) init(); });
})();
